import { ChatAgentConfig, ChatAgentValidationErrors } from './chat-agent-modal.props';

export interface ChatAgentModalState {
  config: ChatAgentConfig;
  errors: ChatAgentValidationErrors;
  isLoading: boolean;
  expandedMcp: number | null;
  mcpSectionExpanded: boolean;
  kbSectionExpanded: boolean;
  selectedKbId: number | null;
  selectedMcpIds: number[];
}

export const initialChatAgentState: ChatAgentModalState = {
  config: {
    name: '',
    description: '',
    selectedModel: '',
    temperature: 0.5,
    maxTokens: 200,
    systemInstructions: '',
    kbAccess: false,
    codeInterpreterAccess: false,
    webSearchAccess: false,
    mcpAccess: false,
  },
  errors: {},
  isLoading: false,
  expandedMcp: null,
  mcpSectionExpanded: false,
  kbSectionExpanded: false,
  selectedKbId: null,
  selectedMcpIds: [],
};

export type ChatAgentModalAction =
  | { type: 'SET_CONFIG'; payload: Partial<ChatAgentConfig> }
  | { type: 'SET_ERRORS'; payload: ChatAgentValidationErrors }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_EXPANDED_MCP'; payload: number | null }
  | { type: 'SET_MCP_SECTION_EXPANDED'; payload: boolean }
  | { type: 'SET_KB_SECTION_EXPANDED'; payload: boolean }
  | { type: 'SET_SELECTED_KB_ID'; payload: number | null }
  | { type: 'SET_SELECTED_MCP_ID'; payload: number | null }
  | { type: 'SET_SELECTED_MCP_IDS'; payload: number[] }
  | { type: 'TOGGLE_MCP_ID'; payload: number }
  | { type: 'RESET_STATE' };

export const chatAgentModalReducer = (
  state: ChatAgentModalState,
  action: ChatAgentModalAction,
): ChatAgentModalState => {
  switch (action.type) {
    case 'SET_CONFIG':
      return { ...state, config: { ...state.config, ...action.payload } };
    case 'SET_ERRORS':
      return { ...state, errors: action.payload };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_EXPANDED_MCP':
      return { ...state, expandedMcp: action.payload };
    case 'SET_MCP_SECTION_EXPANDED':
      return { ...state, mcpSectionExpanded: action.payload };
    case 'SET_KB_SECTION_EXPANDED':
      return { ...state, kbSectionExpanded: action.payload };
    case 'SET_SELECTED_KB_ID':
      return { ...state, selectedKbId: action.payload };
    case 'SET_SELECTED_MCP_ID':
      // For backward compatibility - convert single ID to array
      return {
        ...state,
        selectedMcpIds: action.payload !== null ? [action.payload] : [],
      };
    case 'SET_SELECTED_MCP_IDS':
      return { ...state, selectedMcpIds: action.payload };
    case 'TOGGLE_MCP_ID': {
      const mcpId = action.payload;
      const isSelected = state.selectedMcpIds.includes(mcpId);
      return {
        ...state,
        selectedMcpIds: isSelected
          ? state.selectedMcpIds.filter((id) => id !== mcpId)
          : [...state.selectedMcpIds, mcpId],
      };
    }
    case 'RESET_STATE':
      return initialChatAgentState;
    default:
      return state;
  }
};
